import React from "react";
import { toast, Slide } from "react-toastify";
import strings from "translate/language";
import "./toastNotify.css";

const TOAST_ICONS = {
  success: "fa-check-circle",
  error: "fa-exclamation-circle",
  warning: "fa-exclamation-triangle",
  info: "fa-info-circle",
};

const TOAST_TITLES = {
  success: "Success",
  error: "Error",
  warning: "Warning",
  info: "Notice",
};

function hideGlobalLoader() {
  const loader = window.document.getElementById("loaderoverlay");
  if (loader) {
    loader.style.display = "none";
  }
}

function normalizeMessage(msg) {
  if (msg === null || msg === undefined || msg === "") {
    return "Something went wrong. Please try again.";
  }
  if (typeof msg === "object") {
    return msg.message || JSON.stringify(msg);
  }
  return String(msg);
}

function ToastContent({ type, title, message, iconClass }) {
  const icon = iconClass || TOAST_ICONS[type];

  return (
    <div className={`justo-toast__content justo-toast__content--${type}`}>
      <div className={`justo-toast__icon justo-toast__icon--${type}`}>
        <i className={`fa ${icon}`} aria-hidden="true" />
      </div>
      <div className="justo-toast__text">
        <div className="justo-toast__title">{title}</div>
        <div className="justo-toast__message">{message}</div>
      </div>
    </div>
  );
}

function showToast(type, msg, options = {}) {
  const message = normalizeMessage(msg);
  const title = options.title || TOAST_TITLES[type];
  const iconClass = options.iconClass;

  toast(
    <ToastContent
      type={type}
      title={title}
      message={message}
      iconClass={iconClass}
    />,
    {
      type,
      position: "top-right",
      autoClose: options.autoClose ?? 4000,
      hideProgressBar: false,
      closeOnClick: true,
      pauseOnHover: true,
      draggable: true,
      icon: false,
      transition: Slide,
      className: `justo-toast justo-toast--${type}`,
      progressClassName: `justo-toast__progress justo-toast__progress--${type}`,
      style: { opacity: 1 },
      ...options,
    },
  );

  hideGlobalLoader();
}

export const successToast = (msg, options) => showToast("success", msg, options);

export const errorToast = (msg, options) => showToast("error", msg, options);

export const warnToast = (msg, options) => showToast("warning", msg, options);

export const infoToast = (msg, options) => showToast("info", msg, options);

function formatPropertyToastMessage(template, propertyTitle) {
  const property = String(propertyTitle || "").trim() || "this property";
  return String(template || "").replace(/\{\{property\}\}/g, property);
}

export function greMobileOtpSettingToast(enabled, propertyTitle) {
  if (enabled) {
    successToast(
      formatPropertyToastMessage(
        strings.greMobileOtpActivatedMessage,
        propertyTitle,
      ),
      {
        title: strings.greMobileOtpActivatedTitle,
        iconClass: "fa-mobile",
      },
    );
    return;
  }

  warnToast(
    formatPropertyToastMessage(
      strings.greMobileOtpDeactivatedMessage,
      propertyTitle,
    ),
    {
      title: strings.greMobileOtpDeactivatedTitle,
      iconClass: "fa-phone",
    },
  );
}
